var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showImg)?_c('div',{style:(_vm.iconStyle),domProps:{"innerHTML":_vm._s(_vm.iconContent)}}):_c('img',{style:(_vm.getIconImgStyle),attrs:{"src":_vm.iconSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }